import styled from 'styled-components';
import { Flex } from '../../style';
import { sizes } from '../../variables';

export const Container = styled(Flex)`
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  gap: ${sizes.xl};

  .add-padding {
    padding: 0 ${sizes.md};
  }

  img {
    width: 10%;
  }
  @media screen and (max-width: 425px) {
    font-size: 10px;
    img {
      width: 40%;
    }
  }

  @media screen and (min-width: 426px) and (max-width: 768px) {
    font-size: 12px;
    img {
      width: 30%;
    }
  }

  @media screen and (min-width: 769px) and (max-width: 1024px) {
    img {
      width: 20%;
    }
  }
`